import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import { Link } from "react-router-dom";
import Crmconsulting from "./Crmconsulting";


const Crmconsultingsinglepage: React.FC = () => {
  return (
    <Fragment>
      <div className='about-page inner-page'>
        <div className="body_wrap o-clip">
          <Header/>
          <main>
            <PageTitle pageTitle="CRM Consulting" pagesub="CRM Consulting" />
            <Crmconsulting></Crmconsulting>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Crmconsultingsinglepage;